import { Action } from './actions';

export function showFeedbackReducer(state: boolean = true, action: Action): boolean {
  switch (action.type) {
    case 'FeedbackBannerClosed':
      return false;
    default:
      return state;
  }
}
